export const environment = {
  production: false,
  mode: 'master'
};
